/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://6ofd99jcn4.execute-api.eu-west-3.amazonaws.com/prodd",
            "region": "eu-west-3"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ym6pdzneofdu5kikkbai7zbb3q.appsync-api.eu-west-3.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-3",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-7yatamsq7rcctnhcvkeolehi3y",
    "aws_cognito_identity_pool_id": "eu-west-3:a7318a57-fe00-4f29-bb60-b26dc9da8784",
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_OzJnvQSBg",
    "aws_user_pools_web_client_id": "7minosfpe8im77lh4vq4rljpan",
    "oauth": {
        "domain": "doc2txtamplifyappb2af1a1e-b2af1a1e-prodd.auth.eu-west-3.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.doc2txt.com/,https://app.doc2txt.com/",
        "redirectSignOut": "https://app.doc2txt.com/,https://app.doc2txt.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "doc2txt-tag-data120427-prodd",
    "aws_user_files_s3_bucket_region": "eu-west-3"
};


export default awsmobile;
